import { render } from "./Ubicaciones.vue?vue&type=template&id=db2b5d4c"
import script from "./Ubicaciones.vue?vue&type=script&lang=js"
export * from "./Ubicaciones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__